import type { ShipClockSource } from '@felix/ui';
import { officeApi } from './api.js';

/**
 * Ofiste gemi saati kaydı (M18; ADR 0065 §9): gemi yazar ve kaptan onaylar; ofis `ship_clock.view`
 * yetkili olduğu gemilerin kaydını salt okunur görür.
 */
export const officeShipClockSource: ShipClockSource = {
  scope: 'web',
  load: (query) => officeApi.shipClock({ vesselId: query.vesselId }),
};
